module.exports = {
	"config": {
		"siteTitle": "Blog by Yoni Davidson",
		"siteDescr": "TDD my way around the world",
		"siteAuthor": "Yoni Davidson",
		"siteTelegramUrl": "https://t.me/yonidavidson",
		"siteTwitterUrl": "https://twitter.com/yonidavidson",
		"siteGithubUrl": "https://github.com/yonidavidson",
		"siteEmailUrl": "yonidavidson@gmail.com",
		"googleAnalyticsId": "UA-97082010-1",
		"linkPrefix": "/blog"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-04-10-why-tdd",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-04-10-why-tdd",
				"stem": "index",
				"path": "articles/2017-04-10-why-tdd/index.md"
			},
			"requirePath": "articles/2017-04-10-why-tdd/index.md",
			"path": "/why-tdd/",
			"data": {
				"title": "Why TDD?",
				"date": "2017-04-15",
				"layout": "post",
				"path": "/why-tdd/",
				"category": "Engineering",
				"description": "general rant about software engineering."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-07-10-deeplearning-client-review",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-07-10-deeplearning-client-review",
				"stem": "index",
				"path": "articles/2017-07-10-deeplearning-client-review/index.md"
			},
			"requirePath": "articles/2017-07-10-deeplearning-client-review/index.md",
			"path": "/ai-client-review/",
			"data": {
				"title": "Post WWDC-2017 thoughts on AI?",
				"date": "2017-07-10",
				"layout": "post",
				"path": "/ai-client-review/",
				"category": "AI",
				"description": "A review I did (and sent to my co-workers) after WWDC-2017"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/about",
				"stem": "index",
				"path": "pages/about/index.md"
			},
			"requirePath": "pages/about/index.md",
			"path": "/about/",
			"data": {
				"title": "About me",
				"layout": "page",
				"path": "/about"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/contact",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/contact",
				"stem": "index",
				"path": "pages/contact/index.md"
			},
			"requirePath": "pages/contact/index.md",
			"path": "/contact/",
			"data": {
				"title": "Contact me",
				"layout": "page",
				"path": "/contact"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 383
// module chunks = 0